import { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { showToastError } from 'src/utilities/errortoast';
import * as Yup from 'yup';
import { SuperAdminModal } from '../../../baseComponents';
import {
  getAllPreBuiltSuperAdminTemplatesByPlan,
  getSuperAdminPreBuiltAdminTemplates,
  putSuperAdminPreBuiltAdminTemplates,
} from 'src/modules/ambient_solo/store/actions/settings';

const EditPreBuiltTemplateAdminPage = ({
  isOpen,
  setIsOpen,
  selectedTemplates = [],
  selectedPhase = '',
  selectedOrganizationUUID = '',
}) => {
  const dispatch = useDispatch();
  const {
    templateAdminList,
    isTemplateAdminListLoading,
    templateAdminPlanList,
  } = useSelector((state) => state?.settingsState);
  const [submitLoading, setSubmitLoading] = useState(false);
  const [templateOptions, setTemplateOptions] = useState([]);
  const [selectedTemplateIds, setSelectedTemplateIds] = useState([]);
  const [selectedTemplateOptions, setSelectedTemplateOptions] = useState([]);

  useEffect(() => {
    if (selectedOrganizationUUID) {
      dispatch(getSuperAdminPreBuiltAdminTemplates(selectedOrganizationUUID));
      dispatch(
        getAllPreBuiltSuperAdminTemplatesByPlan(selectedOrganizationUUID)
      );
    }
  }, [selectedOrganizationUUID]);

  useEffect(() => {
    if (templateAdminPlanList?.length > 0) {
      setTemplateOptions(
        templateAdminPlanList
          .filter((template) => template.encounter_phase === selectedPhase)
          .map((template) => ({
            label: template.name,
            value: template.template_id,
          }))
      );
    }
  }, [templateAdminPlanList, selectedPhase]);

  const initialValues = {
    templates: selectedTemplates.map((t) => t.template_id),
    phase: selectedPhase,
  };

  const validationSchemaField = Yup.object().shape({
    templates: Yup.array().min(1, 'Templates are required'),
  });

  const sections = [
    {
      heading: 'Edit template mapping',
      fields: [],
    },
    {
      className: 'flex gap-6 item-center',
      fields: [
        {
          name: 'phase',
          type: 'custom',
          className: 'font-normal text-sm items-center justify-center',
          disabled: true,
          render: () => (
            <span className="justify-center">
              <b>Encounter phase :</b>{' '}
              {initialValues?.phase?.charAt(0)?.toUpperCase() +
                initialValues?.phase?.slice(1)}
            </span>
          ),
        },
      ],
    },
    {
      className: 'grid grid-cols-1 gap-8',
      fields: [
        {
          name: 'templates',
          type: 'select',
          title: 'Templates',
          placeholder: 'Select templates',
          options: templateOptions,
          dropdownMode: 'multiple',
          onChange: (setFieldValue, templateIds, options) => {
            setFieldValue('templates', templateIds);
            setSelectedTemplateIds(templateIds);
          },
        },
      ],
    },
  ];

  return (
    <SuperAdminModal
      open={isOpen}
      sections={sections}
      submitLoading={submitLoading}
      initialValues={initialValues}
      validationSchema={validationSchemaField}
      closable={true}
      submitButtonText="Submit"
      cancelButtonText="Cancel"
      centered={true}
      handleCancel={() => {
        setIsOpen(false);
      }}
      handleSubmit={(values) => {
        if (values.templates.length === 0) {
          showToastError('Please select at least one template');
          return;
        }
        setSubmitLoading(true);
        dispatch(
          putSuperAdminPreBuiltAdminTemplates(
            selectedTemplateIds.map((templateId) => ({
              template_id: templateId,
            })),
            selectedPhase,
            selectedOrganizationUUID
          )
        )
          .then(() => {
            setIsOpen(false);
            dispatch(
              getSuperAdminPreBuiltAdminTemplates(selectedOrganizationUUID)
            );
          })
          .finally(() => {
            setSubmitLoading(false);
          });
      }}
    />
  );
};

export default EditPreBuiltTemplateAdminPage;
